import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  headline() {
    return `${faker.music.songName()} Tour`;
  },

  startDate() {
    return faker.date.future();
  },

  startTime() {
    return this.startDate;
  },

  endDate() {
    return faker.date.future();
  },

  text() {
    return faker.lorem.paragraph();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(mediaEvent, server) {
    let numPartners = faker.datatype.number({
      min: 1,
      max: 2,
    });

    mediaEvent.update({
      artists: server.createList('artist', 1),
      linkId: server.create('link'),
      partners: server.createList('media-partner', numPartners),
    });
  },
});
